module.exports = __webpack_public_path__ + "wireframe3.png?2f8d759e5bd41a9ff532087b46fc5431";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/wireframe3.png
// module id = 237
// module chunks = 0